import React, { forwardRef, useMemo } from 'react';
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import SeekerMappingForm from './SeekerMappingForm';

const SeekerCredentialsForm = forwardRef((props, ref) => {
    const fields = useMemo(() => [
        {
            name: "apiEndpoint",
            label: "API Endpoint",
            required: true,
            rules: [{
                required: true,
                message: "API Endpoint is required."
            }, urlRegexValidator()]
        },
        {
            name: "accessToken",
            label: "Token",
            required: true,
            type: FieldTypes.PASSWORD,
        },
    ], [])
    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={SeekerMappingForm}
        />
    )
});

export default SeekerCredentialsForm;